exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&display=swap);", ""]);

// module
exports.push([module.id, ".tab-digital-menu .v-slide-group__prev{display:none!important}.footer-cart{position:fixed;z-index:3;bottom:0;width:100%;padding:10px}.shake{transform:translateZ(0);animation:shake .98s cubic-bezier(.36,.07,.19,.97) 3}@keyframes shake{10%,90%{transform:rotate(-6deg)}20%,80%{transform:rotate(6deg)}30%,50%,70%{transform:rotate(-6deg)}40%,60%{transform:rotate(6deg)}}.subcategory-tabs{position:fixed;right:0;margin-top:3px;z-index:2}.v-slide-group__prev{display:none!important}", ""]);

// exports
